export default {"src":"/_next/static/media/realTime.3d7b8153.svg","height":61,"width":60};